import{_ as r}from"./_baseFlatten-750d5d67.js";import{_ as t}from"./_overRest-4f494655.js";import{_ as o}from"./_setToString-367edec9.js";var e=function(t){return(null==t?0:t.length)?r(t,1):[]};var n=function(r){return o(t(r,void 0,e),r+"")};export{n as _};
//# sourceMappingURL=_flatRest-e29bc4ca.js.map
